import { call, put, takeLatest } from "redux-saga/effects";
import role from "../actions/role";
import auth from "../actions/auth";
import axios from "../../services/axios";
import roleTypes from "../types/role";

function* inviteDetails({ payload }) {
  try {
    if (payload) {
      const res = yield call(axios.request, {
        method: "GET",
        url: `/jobRoleInvite/report/${payload.id}/${payload.accessCode}`,
        headers: {
          "Content-Type": "application/json",
        },
      });
      if (res.status === 0) {
        const AIMLDetails = res.data.AIMLDetails;
        delete res.data.AIMLDetails;
        yield put(role.inviteDetailsSuccess(res.data));
        yield put(auth.updateAoSI(AIMLDetails));
      } else {
        yield put(role.inviteDetailsFailure(res));
      }
    }
  } catch (err) {
    yield put(role.inviteDetailsFailure(err));
    yield put(auth.apiError(err));
  }
}

function* downloadCR({ payload }) {
  try {
    if (payload) {
      const res = yield call(axios.request, {
        method: "POST",
        url: `/session/downloadFullReport`,
        data: payload,
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token1"),
        },
      });
      yield put(role.downloadCRSuccess(res));
    }
  } catch (err) {
    yield put(auth.apiError(err));
  }
}

function* CandidateProfile({ payload }) {
  try {
    // if (payload) {
    const { candidateId, profileToken } = payload;
    const res = yield call(axios.request, {
      method: "Get",
      url: `/candidate/${candidateId}/profile/${profileToken}`,
      data: payload,
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("token1"),
      },
    });

    if (res.error === true) {
      //status!=0
      yield put(role.CandidateProfileFailure(res));
    } else {
      yield put(role.CandidateProfileSuccess(res));
    }
  } catch (err) {
    yield put(auth.apiError(err));
    yield put(role.CandidateProfileFailure(err));
  }
}

function* CandidateJobSpecificProfile({ payload }) {
  try {
    const { candidateId, roleId, profileToken } = payload;
    const res = yield call(axios.request, {
      method: "Get",
      url: `/jobRole/getCandidateJobRoleProfile/${candidateId}/${roleId}/${profileToken}`,
      data: payload,
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("token1"),
      },
    });
    // console.log("ressssss111111", res);
    if (res.error === true) {
      //status!=0

      yield put(role.CandidateJobSpecificProfileFailure(res));
    } else {
      yield put(role.CandidateJobSpecificProfileSuccess(res));
    }
  } catch (err) {
    // console.log("ressssss111111", err);
    yield put(auth.apiError(err));
    yield put(role.CandidateJobSpecificProfileFailure(err));
  }
}

function* updateTimelineEvents({ payload }) {
  try {
    const res = yield call(axios.request, {
      method: "POST",
      url: `/sessionTracking/updateTimeLineEvent`,
      data: payload,
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("token1"),
      },
    });

    if (res.status !== 0) {
      yield put(role.updateTimelineEventsFailure(res.data));
    } else {
      yield put(role.updateTimelineEventsSuccess(res.data));
    }
  } catch (err) {
    yield put(role.updateTimelineEventsFailure(err));
    yield put(auth.apiError(err));
  }
}

function* getQuesAnsByTrackingId({ payload }) {
  try {
    const res = yield call(axios.request, {
      method: "GET",
      url: `/tracking/getUserQusAnsDetailsByTrackingId/${payload.code}/${payload.trackingId}`,
      data: payload,
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("token1"),
      },
    });

    if (res.status !== 0) {
      yield put(role.getQuesAnsByTrackingIdFailure(res.data));
    } else {
      yield put(role.getQuesAnsByTrackingIdSuccess(res.data));
    }
  } catch (err) {
    yield put(role.getQuesAnsByTrackingIdFailure(err));
    yield put(auth.apiError(err));
  }
}

function* codingSubmissionDetails({ payload }) {
  try {
    const res = yield call(axios.request, {
      method: "GET",
      url: `/tracking/codingSubmissionDetails/${payload.code}`,
      data: payload,
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("token1"),
      },
    });

    if (res.status !== 0) {
      yield put(role.codingSubmissionDetailsFailure(res.data));
    } else {
      yield put(role.codingSubmissionDetailsSuccess(res.data));
    }
  } catch (err) {
    yield put(role.codingSubmissionDetailsFailure(err));
    yield put(auth.apiError(err));
  }
}

function* candidateProfileReport({ payload }) {
  try {
    const res = yield call(axios.request, {
      method: "POST",
      url: `/report/candidateProfile`,
      data: payload,
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("token1"),
      },
    });

    if (res.status !== 0) {
      yield put(role.candidateProfileReportFailure(res.data));
    } else {
      yield put(role.candidateProfileReportSuccess(res.data));
    }
  } catch (err) {
    yield put(role.candidateProfileReportFailure(err));
    yield put(auth.apiError(err));
  }
}

function* profileMatchReport({ payload }) {
  try {
    const res = yield call(axios.request, {
      method: "POST",
      url: `/report/profileMatch`,
      data: payload,
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("token1"),
      },
    });

    if (res.status !== 0) {
      yield put(role.profileMatchReportFailure(res.data));
    } else {
      yield put(role.profileMatchReportSuccess(res.data));
    }
  } catch (err) {
    yield put(role.profileMatchReportFailure(err));
    yield put(auth.apiError(err));
  }
}

function* getBehaviorSkills({ payload }) {
  try {
    const res = yield call(axios.request, {
      method: "GET",
      url: `/user/config/behaviorSkills`,
      data: payload,
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("token1"),
      },
    });

    if (res.status !== 0) {
      yield put(role.getBehaviorSkillsFailure(res.data));
    } else {
      yield put(role.getBehaviorSkillsSuccess(res.data));
    }
  } catch (err) {
    yield put(role.getBehaviorSkillsFailure(err));
    yield put(auth.apiError(err));
  }
}

function* roleSaga() {
  yield takeLatest(roleTypes.INVITE_DETAILS, inviteDetails);
  yield takeLatest(roleTypes.DOWNLOAD_CR, downloadCR);
  yield takeLatest(roleTypes.CANDIDATE_PROFILE, CandidateProfile);
  yield takeLatest(roleTypes.CANDIDATE_JOB_SPECIFIC_PROFILE, CandidateJobSpecificProfile);
  yield takeLatest(roleTypes.UPDATE_TIMELINE_EVENTS, updateTimelineEvents);
  yield takeLatest(roleTypes.GET_QUES_ANS_BY_TRACKING_ID, getQuesAnsByTrackingId);
  yield takeLatest(roleTypes.CODING_SUBMISSION_DETAILS, codingSubmissionDetails);
  yield takeLatest(roleTypes.CANDIDATE_PROFILE_REPORT, candidateProfileReport);
  yield takeLatest(roleTypes.PROFILE_MATCH_REPORT, profileMatchReport);
  yield takeLatest(roleTypes.GET_BEHAVIOR_SKILLS, getBehaviorSkills);
}
export { roleSaga };
